export default "__VITE_ASSET__C3QqIb0v__"